var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherMore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 10.0002C15.4167 10.2303 15.2302 10.4168 15 10.4168C14.7699 10.4168 14.5834 10.2303 14.5834 10.0002C14.5834 9.77004 14.7699 9.5835 15 9.5835C15.2302 9.5835 15.4167 9.77004 15.4167 10.0002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 10.0002C10.4167 10.2303 10.2302 10.4168 10 10.4168C9.76992 10.4168 9.58337 10.2303 9.58337 10.0002C9.58337 9.77004 9.76992 9.5835 10 9.5835C10.2302 9.5835 10.4167 9.77004 10.4167 10.0002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41671 10.0002C5.41671 10.2303 5.23016 10.4168 5.00004 10.4168C4.76992 10.4168 4.58337 10.2303 4.58337 10.0002C4.58337 9.77004 4.76992 9.5835 5.00004 9.5835C5.23016 9.5835 5.41671 9.77004 5.41671 10.0002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherMore);
export default ForwardRef;